<template>
  <div class="data-table">
    <div class="data-table__scroll">
      <table class="data-table__table">
        <thead class="data-table__head">
          <tr>
            <th
              v-for="col in columns"
              :key="col.key"
              scope="col"
              :style="col.minWidth ? { minWidth: col.minWidth } : null"
              :class="[
                'data-table__head-cell',
                headAlignClass(col.align),
                col.sortable ? 'data-table__head-cell--sortable' : '',
                isSorted(col.key) ? 'data-table__head-cell--sorted' : '',
              ]"
              @click="col.sortable ? $emit('sort', col.key) : null"
            >
              <span class="data-table__head-label">
                {{ col.label }}
                <FontAwesomeIcon
                  v-if="col.sortable && getSortIcon"
                  :icon="getSortIcon(col.key)"
                  :class="[
                    'data-table__sort-icon',
                    isSorted(col.key) ? 'data-table__sort-icon--active' : '',
                  ]"
                />
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="data-table__body">
          <tr v-if="loading">
            <td :colspan="columns.length" class="data-table__loading">
              <slot name="loading">
                <Spinner />
              </slot>
            </td>
          </tr>
          <template v-else-if="rows && rows.length">
            <tr
              v-for="(row, index) in rows"
              :key="rowKey ? row[rowKey] : index"
              :class="['data-table__row', clickableRows ? 'data-table__row--clickable' : '']"
              @click="clickableRows ? $emit('row-click', row, index) : null"
            >
              <td
                v-for="col in columns"
                :key="col.key"
                :class="['data-table__cell', cellAlignClass(col.align)]"
              >
                <slot :name="`cell-${col.key}`" :row="row" :index="index">
                  {{ row[col.key] }}
                </slot>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td :colspan="columns.length" class="data-table__empty">
              <slot name="empty">{{ emptyText }}</slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseTable',
  components: { Spinner, FontAwesomeIcon },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'No results found.',
    },
    getSortIcon: {
      type: Function,
      default: null,
    },
    getSortOrder: {
      type: Function,
      default: null,
    },
    clickableRows: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['sort', 'row-click'],
  methods: {
    headAlignClass(align) {
      if (align === 'right') return 'data-table__head-cell--right'
      if (align === 'center') return 'data-table__head-cell--center'
      return ''
    },
    cellAlignClass(align) {
      if (align === 'right') return 'data-table__cell--right'
      if (align === 'center') return 'data-table__cell--center'
      return ''
    },
    isSorted(key) {
      return Boolean(this.getSortOrder && this.getSortOrder(key))
    },
  },
}
</script>
